<template>
  <XTab v-model:modelValue="active" :items="items" @tab-click="handleTabClick" />
  <!-- <ul class="tabs">
    <li
      v-for="(t, idx) in props.tabList"
      :key="idx"
      :class="['tab', { active: idx === active }]"
      @click="() => $emit('update:active', idx)"
    >
      {{ t.tabName }}
    </li>
  </ul> -->
</template>

<script lang="ts" setup>
import type { ScenariosConfigData } from '~/api/interface';
import XTab from '~/design/atom/tab.vue';

const props = defineProps<{ tabList: ScenariosConfigData[]; active: number }>();
const active = ref(props.active);
const emit = defineEmits(['update:active']);

const items = computed(() => {
  return props.tabList.map(item => ({
    title: item.tabName,
    id: item.id,
  }));
});

const handleTabClick = (idx: number) => {
  emit('update:active', idx);
};
</script>
